export const ownerFrontendPath = "/shop/owner";
export const ownerBackendPath = "/backend/shop/owner/";

export const ownerInitChangeMobile = "/backend/shop/owner/init/change/mobile/";

export const ownerChangeMobileFrontendPath = "/shop/owner/change/mobile/:id";
export const ownerChangeMobileBackendPath = "/backend/shop/owner/change/mobile/";

export const ownerConfirmChangeMobileFrontendPath = "/shop/owner/confirm/change/mobile/:id";
export const ownerConfirmChangeMobileBackendPath = "/backend/shop/owner/confirm/change/mobile/";

export const ownerAdminChangeMobileFrontendPath = "/shop/owner/admin/change/mobile/:id";
export const ownerAdminChangeMobileBackendPath = "/backend/shop/owner/admin/change/mobile/";

export const ownerAdminConfirmChangeMobileFrontendPath = "/shop/owner/admin/confirm/change/mobile/:id";
export const ownerAdminConfirmChangeMobileBackendPath = "/backend/shop/owner/admin/confirm/change/mobile/";

export const ownerMergeShopFrontendPath = "/shop/owner/merge/shop/:id";
export const ownerMergeShopBackendPath = "/backend/shop/owner/merge/shop/";

export const emailByShopFrontendPath = "/shop/owner/email/shop/:id";
export const emailByShopBackendPath = "/backend/shop/owner/email/shop/";

export const shopFrontendPath = "/shop";
export const shopBackendPath = "/backend/shop/";

export const shopDisableFrontendPath = "/shop_disable";
export const shopDisableRequestFrontendPath = "/shop_disable/request";
export const shopDisableBackendPath = "/backend/shop/disable/list/";

export const shopUnblockFrontendPath = "/shop_unblock";
export const shopUnblockRequestFrontendPath = "/shop_unblock/request";
export const shopUnblockForceRequestFrontendPath = "/shop_unblock/force/request";

export const shopReportResendFrontendPath = "/shop/report/resend/:id";
export const shopReportResendBackendPath = "/backend/shop/report/resend/";

export const shopMenuImportFrontendPath = "/shop/menu/import/:id";
export const shopMenuImportBackendPath = "/backend/shop/menu/import/";

export const shopMenuPresetFrontendPath = "/shop/menu/preset/:id";
export const shopMenuPresetBackendPath = "/backend/shop/menu/preset/";

export const shopMenuDeleteFrontendPath = "/shop/menu/delete/:id";
export const shopMenuDeleteBackendPath = "/backend/shop/menu/delete/";

export const shopTemplateFrontendPath = "/shop/template";
export const shopTemplateBackendPath = "/backend/shop/template/";

export const shopTemplateCreateFrontendPath = "/shop/template/create";
export const shopTemplateCreateBackendPath = "/backend/shop/template/create/";

export const shopTemplateEditFrontendPath = "/shop/template/:id";
export const shopTemplateEditBackendPath = "/backend/shop/template/edit/";

export const shopCategoryFrontendPath = "/shop/category";
export const shopCategoryBackendPath = "/backend/shop/category/";

export const shopCategoryCreateFrontendPath = "/shop/category/create";
export const shopCategoryCreateBackendPath = "/backend/shop/category/create/";

export const shopCategoryEditFrontendPath = "/shop/category/:id";
export const shopCategoryEditBackendPath = "/backend/shop/category/edit/";

export const shopCategoryDetailFrontendPath = "/shop/category/:id/detail";
export const shopCategoryDetailBackendPath = "/backend/shop/category/detail/";

export const shopItemFrontendPath = "/shop/item";
export const shopItemBackendPath = "/backend/shop/item/";

export const shopItemCreateFrontendPath = "/shop/item/create";
export const shopItemCreateBackendPath = "/backend/shop/item/create/";

export const shopItemEditFrontendPath = "/shop/item/:id";
export const shopItemEditBackendPath = "/backend/shop/item/edit/";

export const shopMenuListFrontendPath = "/shop/menu";
export const shopMenuListBackendPath = "/backend/shop/menu/";

export const shopLoginWhitelistFrontendPath = "/shop/login/whitelist";
export const shopLoginWhitelistBackendPath = "/backend/shop/login/whitelist/";

export const shopLoginWhitelistCreateFrontendPath = "/shop/login/whitelist/create/";
export const shopLoginWhitelistCreateBackendPath = "/backend/shop/login/whitelist/create/";

export const shopLoginWhitelistEditFrontendPath = "/shop/login/whitelist/:id";
export const shopLoginWhitelistEditBackendPath = "/backend/shop/login/whitelist/edit/";

export const shopPushDeviceListFrontendPath = "/shop_push_device_list/:id";
export const shopPushDeviceListBackendPath = "/backend/shop/push_device_list/";

export const shopLoginDisableFrontendPath = "/shop_login_disable";
export const shopLoginDisableBackendPath = "/backend/auth/disabled_account/";
export const shopLoginDisableRevertBackendPath =
  "/backend/auth/disabled_account/revert/";


// WEBPACK FOOTER //
// ./src/routes/shop/urls.js